import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../contexts/AuthContext";

const PrivateRoute = ({ requiredRole, children }) => {
  const { user, isLoading } = useAuthContext();
  const location = useLocation();

  if (isLoading) {
    return <div>Loading...</div>; // Display a loading indicator while user data is being processed
  }

  if (!user) {
    console.warn("User not logged in. Redirecting to login.");
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  console.log("User role:", user.role);
  console.log("Required role(s):", requiredRole);

  // Check access for all roles or specific role(s)
  const hasAccess =
    requiredRole === "All" || // Allow all roles
    (Array.isArray(requiredRole)
      ? requiredRole.includes(user.role) // Multiple roles
      : user.role === requiredRole); // Single role

  if (!hasAccess) {
    console.warn(`Access denied. User role: ${user.role}`);
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default PrivateRoute;
